module.exports = __webpack_public_path__ + "static/img/Registrobr4.2aae850.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/faq/Registrobr4.png
// module id = 1771
// module chunks = 5